'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n  '], ['\n    width: 100%;\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _partial = require('transmute/partial');

var _partial2 = _interopRequireDefault(_partial);

var _colors = require('HubStyleTokens/colors');

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _PricingSelectors = require('pricing-pages-unified-ui/selectors/PricingSelectors');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _merchandiseUtils = require('../../../utils/merchandiseUtils');

var _BundlePage = require('../BundlePage');

var _utils = require('../utils');

var _pricingUtils = require('pricing-pages-unified-ui/utils/pricingUtils');

var _ContactsItem = require('./ContactsItem');

var _ContactsItem2 = _interopRequireDefault(_ContactsItem);

var _EmptyShoppingCart = require('./EmptyShoppingCart');

var _EmptyShoppingCart2 = _interopRequireDefault(_EmptyShoppingCart);

var _ShoppingCartItem = require('./ShoppingCartItem');

var _ShoppingCartItem2 = _interopRequireDefault(_ShoppingCartItem);

var _ShoppingCartPrices = require('./ShoppingCartPrices');

var _ShoppingCartPrices2 = _interopRequireDefault(_ShoppingCartPrices);

var _BundlePricingBreakdownModal = require('../BundlePricingBreakdownModal');

var _BundlePricingBreakdownModal2 = _interopRequireDefault(_BundlePricingBreakdownModal);

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _BundlesCTA = require('pricing-pages-unified-ui/components/bundle-page/BundlesCTA');

var _BundlesCTA2 = _interopRequireDefault(_BundlesCTA);

var _responsiveBreakpoints = require('../../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

var _UIScrollContainer = require('UIComponents/scroll/UIScrollContainer');

var _UIScrollContainer2 = _interopRequireDefault(_UIScrollContainer);

var _RequestStatusTypes = require('pricing-pages-unified-ui/constants/RequestStatusTypes');

var _RequestStatusTypes2 = _interopRequireDefault(_RequestStatusTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ShoppingCartContainer = _styledComponents2.default.div.withConfig({
  displayName: 'ShoppingCart__ShoppingCartContainer'
})(['border:1px ', ' solid;width:340px;padding:20px 20px 0 20px;margin-bottom:20px;', ';'], _colors.BATTLESHIP, _responsiveBreakpoints2.default.cs(_templateObject));

var Spacer = _styledComponents2.default.div.withConfig({
  displayName: 'ShoppingCart__Spacer'
})(['height:1px;width:100%;background-color:', ';margin:20px 0;'], _colors.BATTLESHIP);

var BundleTitle = _styledComponents2.default.div.withConfig({
  displayName: 'ShoppingCart__BundleTitle'
})(['font-weight:600;margin-bottom:10px;']);

var PricingBreakdownSection = _styledComponents2.default.div.withConfig({
  displayName: 'ShoppingCart__PricingBreakdownSection'
})(['border-top:1px ', ' solid;padding:15px 0;margin:10px -20px 0;background-color:', ';text-align:center;'], _colors.BATTLESHIP, _colors.GYPSUM);

function ShoppingCart(_ref) {
  var pricingDependencies = _ref.pricingDependencies,
      purchaseMotionRequestStatus = _ref.purchaseMotionRequestStatus;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      mergeState = _useContext.mergeState;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isModalVisible = _useState2[0],
      setModalVisibility = _useState2[1];

  var togglePriceBreakdown = function togglePriceBreakdown(isVisible) {
    setModalVisibility(isVisible);

    if (isVisible) {
      (0, _getUsageTracker2.default)().track('clickToViewModal', {
        name: 'price-breakdown-modal'
      });
    }
  };

  var marketingPlanSelected = state.marketingPlanSelected,
      salesPlanSelected = state.salesPlanSelected,
      servicePlanSelected = state.servicePlanSelected,
      salesUnits = state.salesUnits,
      serviceUnits = state.serviceUnits,
      selectedAddOns = state.selectedAddOns,
      selectedServices = state.selectedServices,
      marketingUnits = state.marketingUnits;


  var isCartEmpty = !marketingPlanSelected && !salesPlanSelected && !servicePlanSelected && selectedAddOns.isEmpty() && selectedServices.isEmpty();
  var isLoadingPurchaseMotions = purchaseMotionRequestStatus !== _RequestStatusTypes2.default.SUCCEEDED;

  if (isCartEmpty || isLoadingPurchaseMotions) {
    return _react2.default.createElement(
      ShoppingCartContainer,
      null,
      _react2.default.createElement(_EmptyShoppingCart2.default, null)
    );
  }

  var bundleUrl = (0, _utils.generateBundleUrl)({
    marketingPlanSelected: marketingPlanSelected,
    salesPlanSelected: salesPlanSelected,
    servicePlanSelected: servicePlanSelected,
    marketingUnits: marketingUnits,
    salesUnits: salesUnits,
    serviceUnits: serviceUnits,
    selectedAddOns: selectedAddOns,
    selectedServices: selectedServices
  });

  var totalPrice = (0, _pricingUtils.calculateBundlePrice)({
    marketingPlanSelected: marketingPlanSelected,
    salesPlanSelected: salesPlanSelected,
    servicePlanSelected: servicePlanSelected,
    marketingUnits: marketingUnits,
    salesUnits: salesUnits,
    serviceUnits: serviceUnits,
    selectedAddOns: selectedAddOns,
    selectedServices: selectedServices,
    pricingDependencies: pricingDependencies
  });

  var merchandiseIds = (0, _utils.bundleMerchandiseIds)({
    marketingPlanSelected: marketingPlanSelected,
    salesPlanSelected: salesPlanSelected,
    servicePlanSelected: servicePlanSelected,
    selectedAddOns: selectedAddOns,
    selectedServices: selectedServices
  });

  var propsToPass = {
    marketingPlanSelected: marketingPlanSelected,
    salesPlanSelected: salesPlanSelected,
    servicePlanSelected: servicePlanSelected,
    marketingUnits: marketingUnits,
    salesUnits: salesUnits,
    serviceUnits: serviceUnits,
    selectedAddOns: selectedAddOns,
    selectedServices: selectedServices,
    pricingDependencies: pricingDependencies
  };

  var gaClassName = (0, _publicPageUrls.getGAClassName)('bundle-pricing-breakdown');

  return _react2.default.createElement(
    ShoppingCartContainer,
    null,
    _react2.default.createElement(_BundlesCTA2.default, { merchandiseIds: merchandiseIds, bundleUrl: bundleUrl }),
    _react2.default.createElement(Spacer, null),
    _react2.default.createElement(
      BundleTitle,
      null,
      _react2.default.createElement(_FormattedMessage2.default, { message: 'bundles.shoppingCart.yourBundle' })
    ),
    _react2.default.createElement(
      _UIScrollContainer2.default,
      { maxHeight: 380, gradientColor: _colors.GREAT_WHITE },
      marketingPlanSelected && _react2.default.createElement(_ContactsItem2.default, null),
      salesPlanSelected && _react2.default.createElement(_ShoppingCartItem2.default, {
        merchandiseId: salesPlanSelected,
        additionalUnitQuantity: salesUnits,
        unit: _react2.default.createElement(_FormattedMessage2.default, {
          message: 'bundles.shoppingCart.additionalUsers',
          options: {
            count: (0, _merchandiseUtils.includedAdditionalUnits)(salesPlanSelected) + salesUnits
          }
        }),
        onRemove: function onRemove() {
          return mergeState({ salesPlanSelected: null, salesUnits: 0 });
        }
      }),
      servicePlanSelected && _react2.default.createElement(_ShoppingCartItem2.default, {
        merchandiseId: servicePlanSelected,
        additionalUnitQuantity: serviceUnits,
        unit: _react2.default.createElement(_FormattedMessage2.default, {
          message: 'bundles.shoppingCart.additionalUsers',
          options: {
            count: (0, _merchandiseUtils.includedAdditionalUnits)(servicePlanSelected) + serviceUnits
          }
        }),
        onRemove: function onRemove() {
          return mergeState({ servicePlanSelected: null, serviceUnits: 0 });
        }
      }),
      selectedAddOns.map(function (merchandiseId) {
        var onRemove = function onRemove() {
          return mergeState({
            selectedAddOns: selectedAddOns.delete(merchandiseId)
          });
        };
        return _react2.default.createElement(_ShoppingCartItem2.default, {
          key: merchandiseId,
          merchandiseId: merchandiseId,
          onRemove: onRemove
        });
      }),
      selectedServices.map(function (merchandiseId) {
        var onRemove = function onRemove() {
          return mergeState({
            selectedServices: selectedServices.delete(merchandiseId)
          });
        };
        return _react2.default.createElement(_ShoppingCartItem2.default, {
          key: merchandiseId,
          merchandiseId: merchandiseId,
          onRemove: onRemove
        });
      })
    ),
    _react2.default.createElement(Spacer, null),
    _react2.default.createElement(_ShoppingCartPrices2.default, { totalPrice: totalPrice }),
    _react2.default.createElement(
      PricingBreakdownSection,
      null,
      _react2.default.createElement(
        _UILink2.default,
        {
          onClick: (0, _partial2.default)(togglePriceBreakdown, true),
          className: gaClassName
        },
        _react2.default.createElement(_FormattedMessage2.default, {
          className: gaClassName,
          message: 'pricingPage.calculator.priceBreakdown.link'
        })
      )
    ),
    isModalVisible && _react2.default.createElement(_BundlePricingBreakdownModal2.default, _extends({
      totalPrice: totalPrice,
      onCloseClick: (0, _partial2.default)(togglePriceBreakdown, false)
    }, propsToPass))
  );
}

var mapStateToProps = function mapStateToProps(state) {
  return {
    pricingDependencies: (0, _PricingSelectors.pricingDependenciesSelector)(state),
    purchaseMotionRequestStatus: state.purchaseMotionRequestStatus
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(ShoppingCart);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/shopping-cart/ShoppingCart.js
// module id = 705
// module chunks = 3 4